import React from 'react';
import { Card, Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import logoDark from '../../assets/images/Pertamina_Logo.png';
import logoLight from '../../assets/images/pertamina-white.svg';
import AuthSlider from './authCarousel';
import LoginBackground from './LoginBackground';

// Kerangka halaman auth (login, registrasi supplier): background, carousel kiri, panel form kanan.
const AuthCardLayout = ({ title, subtitle, children }) => (
  <div className='login-corporate login-page d-flex justify-content-center align-items-center min-vh-100'>
    <LoginBackground />

    {/* Jalan pulang ke landing HYROC (D-26). Di luar Container supaya
        menempel ke pojok layar seperti pada rancangan. */}
    <Link to='/' className='login-back-home'>
      <i className='ri-home-4-line' aria-hidden='true' />
      Back to Home
    </Link>

    <Container className='login-container position-relative'>
      <Row className='justify-content-center'>
        <Col xl={12} lg={12}>
          <Card className='login-card border-0 overflow-hidden'>
            <Row className='g-0'>
              <AuthSlider />
              <Col lg={6}>
                <div className='login-form-panel d-flex flex-column h-100'>
                  <div className='login-form-accent' aria-hidden='true' />

                  <div className='login-hero-mobile d-lg-none position-relative'>
                    <div className='login-hero-overlay' />
                    <div className='login-hero-content p-4'>
                      <img
                        src={logoLight}
                        alt='Pertamina'
                        height='34'
                        className='mb-2'
                      />
                      <p className='login-hero-desc mb-0'>
                        HYROC — Digital Hydrocarbon Procurement
                      </p>
                    </div>
                  </div>

                  <div className='login-form-body flex-grow-1 d-flex flex-column p-lg-5 p-4'>
                    <div className='login-form-header mb-4'>
                      <div className='d-none d-lg-flex align-items-center mb-4'>
                        <img src={logoDark} alt='Pertamina' height='38' />
                      </div>
                      <h4 className='login-form-title mb-1'>{title}</h4>
                      {subtitle && (
                        <p className='login-form-subtitle mb-0'>{subtitle}</p>
                      )}
                    </div>

                    {children}
                  </div>

                  <div className='login-form-footer'>
                    &copy; {new Date().getFullYear()} PT Pertamina (Persero).
                    All rights reserved.
                  </div>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Container>
  </div>
);

export default AuthCardLayout;
